<script>

  import Squared from '/components/Atoms/Squared'
  import WidgetImage from '/components/Widgets/WidgetImage.svelte'
  import CardMedia from '/components/Widgets/CardMedia.svelte'
  import CardImage from '/components/Widgets/CardImage.svelte'
  import PolyMedia from '/Widgets/PolyMedia'

  import Queer from '/components/Widgets/Queer.svelte'
  import { _ } from 'svelte-i18n'

  export let widgets

  let maxAmount = 12

  const dataItems = widgets.map( w => {
    // gather information
    const bgImage = w?.backgroundImage?.[0]?.url
    const bgImage2x = w?.backgroundImage?.[0]?.url2x
    const bgImageWebp = w?.backgroundImage?.[0]?.urlWebp
    const bgImageWebp2x = w?.backgroundImage?.[0]?.urlWebp2x
    const bgImageLarge = w?.backgroundImage?.[0]?.urlLarge
    const bgImageLarge2x = w?.backgroundImage?.[0]?.urlLarge2x
    const bgImageLargeWebp = w?.backgroundImage?.[0]?.urlLargeWebp
    const bgImageLargeWebp2x = w?.backgroundImage?.[0]?.urlLargeWebp2x
    const title = w.title
    const text = w.widgetText
    const entryType = w.typeHandle
    const contentType = w.widgetSubType
    const linkedContent = w?.linkedContent?.[0]
    const typeHandle = linkedContent?.typeHandle
    const link = linkedContent ? { slug: linkedContent.slug, section: "almanac"} : null

    // console.log(w?.backgroundImage?.[0])

    // decide on component

    //// static widgets ////

    // image
    if (entryType === "staticWidget" && contentType === "2021AlmanacSquareImageOnly") {
      return {
        outline: "rect",
        component: CardImage,
        props: {
          image: bgImage,
          image2x: bgImage2x,
          imageWebp: bgImageWebp,
          imageWebp2x: bgImageWebp2x,
          standardRadius: true
        }
      }
    }

    // image without borders (no card)
    if (entryType === "staticWidget" && contentType === "2021AlmanacImageOnly") {
      return {
        outline: "none",
        component: WidgetImage,
        props: {
          image: bgImage,
          image2x: bgImage2x,
          imageWebp: bgImageWebp,
          imageWebp2x: bgImageWebp2x,
        }
      }
    }

    // Queer API

    if (entryType === "staticWidget" && contentType === "2021AlmanacQueerApi") {
      return { 
        outline: "round",
        component: Queer 
      }
    }
    

    //// linked content widgets ////

    if (entryType === "contentWidget") {

      const people = linkedContent?.relatedPeople?.[0]?.members?.map( member => member.title).join(", ")
      const category = linkedContent?.textMediaCategory || linkedContent?.collectionType?.[0]
      
      // CARDS - small and large - green and non-green
      if ([
          "2021AlmanacStandardContent", 
          "2021AlmanacLargeContent",
          "2021AlmanacStandardContentGreenBg",
          "2021AlmanacLargeContentGreenBg"
        ].includes(contentType) ) {

        const large = ["2021AlmanacLargeContent", "2021AlmanacLargeContentGreenBg"].includes(contentType)
        const green = ["2021AlmanacStandardContentGreenBg", "2021AlmanacLargeContentGreenBg"].includes(contentType)

        return {
          outline: "rect",
          component: CardMedia,
          large,
          props: {
            category,
            title: text,
            subtitle: people,
            image: large ? bgImageLarge : bgImage,
            image2x: large ? bgImageLarge2x : bgImage2x,
            imageWebp: large ? bgImageLargeWebp : bgImageWebp,
            imageWebp2x: large ? bgImageLargeWebp2x : bgImageWebp2x,
            imageContain: green,
            highlight: large,
            standardRadius: true,
            bgColorKey: "beige",
            smallFonts: true,
            typeHandle,
            link
          }
        }
      }

      // POLYGONS
      if (["2021AlmanacPolygonContent", "2021AlmanacCircleContent", "2021AlmanacPolygonContentGreenBg"].includes(contentType) ) {

        const n = contentType === "2021AlmanacPolygonContent" ? 10 : 17
        const green = contentType === "2021AlmanacPolygonContentGreenBg"

        return {
          outline: "poly",
          component: PolyMedia,
          props: {
            category,
            title: text,
            subtitle: people,
            bgImage,
            bgImage2x: bgImage2x,
            bgImageWebp: bgImageWebp,
            bgImageWebp2x: bgImageWebp2x,
            imageContain: green,
            typeHandle,
            link,
            n
          }
        }
      }

    }

  //// link widgets ////

  // image without borders (no card)
  if (entryType === "linkWidget" && contentType === "2021AlmanacAdvertisement") {
    return {
      outline: "none",
      component: WidgetImage,
      props: {
        category: "Advertisement",
        image: bgImage,
        image2x: bgImage2x,
      }
    }
  }
    
    // otherwise
    
    return false

  }).filter(i => i !== false)

  const items = dataItems//.concat(exampleItems)

  const loadmore = () => {
    maxAmount += 12
  }

</script>

<div class="container">
  {#if items.length > 0}
    {#each items as item, index}
      {#if index < maxAmount}
        <div class="item" data-outline={item.outline} class:large={item.large}>
          <svelte:component this={item.component} {...item.props}>
            { item.content }
          </svelte:component>
        </div>
      {/if}
    {/each}
  {:else}
    <Squared>
      <div class="noResults">
        No results found
      </div>
    </Squared>
  {/if}
</div>

{#if maxAmount < items.length}
  <div class="loadmore">
    <button class="loadmore_button" on:click={loadmore}>
      {$_('general.load_more')}
    </button>
  </div>
{/if}

<style lang="scss">

  .container {
    display: grid;
    grid-auto-flow: row dense;
    @include grid-margin;

    @include media-1col-only {
      grid-template-columns: repeat( 1, 1fr );
    }

    @include media-2col {
      grid-template-columns: repeat( 2, 1fr );
      @include grid-template-rows-square(2);
    }

    @include media-large-only {
      grid-template-columns: repeat( 3, 1fr );
      @include grid-template-rows-square(3);
    }

    @include media-3col {
      grid-template-columns: repeat( 4, 1fr );
      @include grid-template-rows-square(4);
    }

    column-gap: $grid-gap-large;
    row-gap: $grid-gap-large;
    @include media-small {
      column-gap: $grid-gap-small;
      row-gap: $grid-gap-small;
    }

    padding-bottom: 70px;
    @include media-small {
      padding-bottom: 60px;
    }
  }

  .item {

    @include media-1col-only {
      @include height-square;
    }

    &[data-outline="poly"] {
      margin: $grid-gap-large * -.25;
      @include media-small {
        margin: $grid-gap-small * -.25;
      }
    }

    &.large {
      @include media-2col {
        grid-column: span 2;
      }
      @include media-1col-only {
        @include height-square(1, 4/3);
      }
    }
  }

  .loadmore {
    text-align: center;
    padding-bottom: 40px;
    position: relative;
    bottom: 30px;
    @include media-small {
      bottom: 20px;
    }
    .loadmore_button {
      background-color: $color-red;
      color: $color-beige;
      border: none;
      @include typo-grotesk-title-22;
      padding: 18px 28px 14px;
      border-radius: 30px;
      box-shadow: $shadow;
      cursor: pointer;
    }
  }

  .noResults {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: $shadow;
    border-radius: 15px;
    @include typo-grotesk-text-24;
    color: $color-red;
    text-align: center;
  }

</style>